// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"3f6ebed8","247":"cf51aad5","321":"57f8de95","453":"bf35e0b7","551":"d81471bc","627":"8e9f6d2a","628":"89b3d92d","653":"bc21c593","738":"4157d3f8","768":"fcc9a0bb","834":"cb352368","923":"1c5ee226","938":"0add4e6a"}[chunkId] + ".chunk.js";
};